module.exports = __webpack_public_path__ + "img/background.3db31dfe.png";